import { Component, OnInit, OnDestroy, AfterViewInit, ViewChildren, ViewChild, TemplateRef } from '@angular/core';
import { PassionProjects } from 'src/app/model/PassionProject';
import { Subscription, Observable } from 'rxjs';
import { PassionProjectService } from 'src/app/services/passion-project.service';
import { SharedPassionProjectService } from 'src/app/services/shared-passion-project.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Teams, EditTeamRequest } from 'src/app/model/passion-project-teams';
import { NgbModal, NgbModalConfig, NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, map, finalize } from 'rxjs/operators';
import { NotificationService } from 'src/app/services/notification.service';
import { PassionProjectTeamService } from '../../services/shared-services/passion-project-team.service';
import { UserRole } from 'src/app/shared/user-role';
import { SocketService } from 'src/app/services/web/socket.service';
import { CommonService } from 'src/app/services/common.service';
import { environment } from '../../../environments/environment';
import { CreateEventComponent } from '../create-event/create-event.component';
import { CalendarService } from 'src/app/calendar-schedule/services/calendar.service';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { Roles } from 'src/app/auth/roles.enum';
import { DatePipe } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { HeaderService } from 'src/app/services/header.service';

interface MemberFeedbackContext {
  member: any;
  team: Teams;
  rating: number;
  comment: string;
}

@Component({
  selector: 'app-project-view',
  templateUrl: './project-view.component.html',
  styleUrls: ['./project-view.component.scss']
})
export class ProjectViewComponent implements OnInit, OnDestroy, AfterViewInit {

  disabled = false;

  showProjres: boolean = false;

  public loader = false;  // change by samir for production release
  public passionProject!: any;
  public sharedPassionProjectSubscription: Subscription;

  public teamList: Teams[];
  public sharedTeamListSubscription: Subscription;

  public projectTeams: Teams[];

  public searchTeamModalRef = null;
  public createTeamModalRef = null;
  public searchedTeam: Teams;
  public userId: string;

  public UserRole = new UserRole();
  projectResData: any;
  youtubeLinkFlag: boolean;
  passion_project_mentor_list = [];
  passionProjectWebinars:any = [];
  webinarRecoredings:any = [];
  @ViewChildren('scrollMe') myScrollContainer;
  @ViewChild(CreateEventComponent, { static: false }) createEventTrigger: CreateEventComponent;
  @ViewChild('memberFeedbackModal', { static: false }) memberFeedbackModal: TemplateRef<any>;

  processLoader = false;

  passionProjectId: string = '';
  role: string = '';
  projectPublishStatus:boolean = false;
  isMentorProfile:boolean = false;
  defaultThumbnailPic: string = environment.imageBasePath + environment.userDefaultProfilePic;
  allowedRoles:Roles[] = [Roles.TEACHER, Roles.MENTOR];   
  expandedTeamIds: Set<string> = new Set<string>();
  teamDetailsLoading: Set<string> = new Set<string>();
  teamDetailsLoaded: Set<string> = new Set<string>();
  selectedEvent: any = null;
  isEditRights:boolean = false;
  deleteEventModelClose:boolean = false;
  deleteEventModelOpen:boolean = false;
  deleteloader:boolean = false;
  deleteWebinarData:any = null;
  hasStudentRole:string = '';
  isISDMOrg: boolean = false;
  private orgLogoSub?: Subscription;

  readonly ROLE_STUDENT = Roles.STUDENT;
  readonly ROLE_TEACHER = Roles.TEACHER;
  readonly ROLE_MENTOR = Roles.MENTOR;
  readonly ROLE_SUPER_ADMIN = Roles.SUPER_ADMIN;
  readonly ROLE_ORG_ADMIN = Roles.ORG_ADMIN;

  processingStatus: boolean = false;
  processingCompleted: boolean = false;
  memberFeedbackModalRef: any = null;
  feedbackContext: MemberFeedbackContext | null = null;

  constructor(
    private datePipe: DatePipe,
    private socket_service: SocketService,
    private activate_route: ActivatedRoute,
    private router: Router,
    private ngModal: NgbModal,
    private ns: NotificationService,
    private _passionProjectService: PassionProjectService,
    private _sharedPassionProjectService: SharedPassionProjectService,
    private _sharedPassionProjectTeamService: PassionProjectTeamService,
    private modalReview: NgbModal,
    config: NgbModalConfig, private modalService: NgbModal,
    private commonService: CommonService,
    private calendarService:CalendarService,
    public perm: AuthorizationService,
    private headerService: HeaderService
  ) {
    config.backdrop = 'static';
  }

  ngOnInit() {
    this.role = this.UserRole.userRole;
    this.userId = localStorage.getItem('user_id');
    let isMentor = localStorage.getItem('isMentorProfile');
    this.isMentorProfile = Boolean(isMentor);
    let  pp_status = localStorage.getItem('_Passion_Publish_Status');
    this.hasStudentRole = Roles.STUDENT;  
    this.projectPublishStatus = JSON.parse(pp_status);
    this.orgLogoSub = this.headerService.orgLogo.subscribe((logoData: any) => {
      this.isISDMOrg = logoData && logoData.organizationSubDomain ? logoData.organizationSubDomain.toLowerCase() === 'isdm' : false;
    });
    this.activate_route.queryParams.subscribe(params => {
      this.passionProjectId = params.id;
      this.getPassionProject();
    });

    if (this.socket_service.sockets.disconnected) {
      this.socket_service.connection();
    }

  }

  recommendedStudents: any[] = [];
  isRecommendedLoading: boolean = false;
  recommendedPage: any = "1";

  fetchRecommendedStudents(projectTags: any) {
    const searchQuery = projectTags.map(t => t.tag).filter(Boolean).join(',');
    this._passionProjectService.searchStudents(searchQuery).subscribe(
      (response: any) => {
        this.recommendedStudents = response.data || [];
        this.isRecommendedLoading = false;
      },
      (err: any) => {
        this.isRecommendedLoading = false;
        this.ns.showNotification('error', err.message);
      }
    );


  }

  ngAfterViewInit() {
    //  this.scrollToBottom();
  }

  // check role
  get isTeacherOrMentor(): boolean {
    return ['teacher', 'mentor'].includes(this.role);
  }


  scrolldelay;
  scrollToBottom(): void {
    if (this.myScrollContainer) {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    }
  }
  //FOR MANAGE EVENT
  onEventSave(data) {
    if (data.status == true) {
      this.getPassionProject();
    }
  }

  projectStatusOptions = [
  { label: 'Not started', value: 'not_started' },
  { label: 'In progress', value: 'in_progress' },
  { label: 'Completed', value: 'completed' },
  { label: 'On hold / paused', value: 'on_hold' }
];

getProjectStatusLabel(status?: string): string {
  if (!status) {
    return '-';
  }

  const match = this.projectStatusOptions.find(
    option => option.value === status
  );

  return match ? match.label : '-';
}

  getPassionProject() {

    //GET PROJECT FROM NEW API
    if (this.passionProjectId) {
      this.loader = true;
      this.webinarRecoredings = [];
      this._passionProjectService
        .getPassionProject(this.passionProjectId)
        .subscribe(
          res => {
            this.passionProject = res.projects;
            this.isEditRights = res.projects.edit_rights;
            this.fetchRecommendedStudents(this.passionProject.project_tags);

            this.passionProjectWebinars = this.passionProject.project_webinar.map(item => ({
              ...item,
              isEditable:this.handleTwoHourPreEventLogic(item.start, 120),
              isCompleted: new Date(item.end) < new Date() ? true : false
            }));

          this.webinarRecoredings =  this.passionProjectWebinars.filter((webinar:any)=>{
            return webinar.url !== ''; 
          })
            
            // for(let i = 0; i < this.passionProject.project_resources.length; i++){
            //   let splitTile = this.passionProject.project_resources[i].title.split('.');
            //   let fileExtenion = splitTile.pop();

            //  console.log(fileExtenion);

            // }

            //CHECK PUBLISH STATUS
            // if (this.role == 'student' && !this.passionProject.publish) {
            //   this.router.navigate(['/passion-projects']);
            //   return false;
            // }

            this._sharedPassionProjectService.changePassionProject(this.passionProject);
            this.updateTagColors();
            this.getTeams();
            this.loader = false
          },
          err => {
            this.loader = false
            this.ns.showNotification('error', err.message);
          }
        );
    }

    //GET PROJECT FROM SHARED SERVICE
    if (!this.passionProjectId) {
      this.sharedPassionProjectSubscription = this._sharedPassionProjectService
        .passionProject
        .subscribe(
          res => {
            if (Object.keys(res).length < 1) return this.redirect('/passion-projects');
            this.passionProject = res as PassionProjects;
            this.updateTagColors();
            this.getTeams();
          }
        );
    }
  }


  getDisplayDate(value: any): string {
  if (!value) return '-';

  const date = new Date(value);
  return isNaN(date.getTime())
    ? '-'
    : this.datePipe.transform(date, 'MMMM d, y') || '-';
}


  
  normalizeDate(value: any): Date | null {
  if (!value) return null;

  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
}

  editWebinar(webinarEvent:any){
    this.selectedEvent = webinarEvent;
    this.calendarService.sendEventAction({ action: 'edit', selectedEvent: this.selectedEvent});
  }


  deleteWebinar(webinarData:any){
    this.deleteWebinarData = webinarData;
    this.deleteEventModelOpen = true;
  }

  emitedDeleteEvent(event){
    if(event){
      this.onDeleteEvent();
    }
  }
  
  onDeleteEvent() {
    this.deleteloader = true;
    if(this.role === Roles.MENTOR || this.role === Roles.TEACHER || this.role === Roles.ORG_ADMIN || this.role === Roles.SUPER_ADMIN){
      if(!this.handleTwoHourPreEventLogic(this.deleteWebinarData.start, 120)){
        this.ns.showNotification("error", 'You are too late to delete the webinar. Please refresh the page and check again.');
        return false;
      }

      let jsonEvent = {};
      jsonEvent['type'] = 'webinar';
      jsonEvent['meeting_session_id'] = this.deleteWebinarData.webinar_id;

      this.calendarService.deleteEventWebinarSession(jsonEvent).subscribe(req => {
        this.deleteloader = false;
        this.ns.showNotification("success", "Event deleted successfully");
        this.closeDeleteModalPopup(true);
        this.getPassionProject();
      },
        (err) => {
          this.deleteloader = false;
          this.ns.showNotification("error", err.message);
        });
    } 
  }

  closeDeleteModalPopup(event){
    if(event){
      this.deleteEventModelOpen = false;
    }
  }

  
    // join/start call button will be visible before 15 Minutes of start time
  handleTwoHourPreEventLogic(startTime:any, visibleBefore:number): boolean {
    const currentTime = new Date();
    let getStartTime = new Date(startTime);
    getStartTime.setMinutes(getStartTime.getMinutes() - visibleBefore);
    return currentTime.getTime() < getStartTime.getTime();
  }


  //TAGS COLORS
  updateTagColors() {
    if (this.passionProject.project_tags) {
      for (let i = 0; i < this.passionProject.project_tags.length; i++) {
        this.passionProject.project_tags[i].bgColor = this.commonService.randomBgColor();
      }
    }
  }

  is_chat_room() {
    if (this.passionProject.mentor_chat['room_status']) {
      return true;
    }
    return false;
  }

  getTeams() {

    //FOR NEW DESIGN
    this.getTeamsById();
    
    //GET USERS CHAT
    if (this.is_mentor_present()) {
      this.get_passion_project_proposal();
    };
  }

  getTeamsById() {
    this.processLoader = true;
    this._passionProjectService
      .getTeamsById(this.passionProject._id)
      .pipe(finalize(() => this.processLoader = false))
      .subscribe(
        res => {
          this.role = res.user_role;
          this.expandedTeamIds.clear();
          this.teamDetailsLoaded.clear();
          this.teamDetailsLoading.clear();
          this.projectTeams = res.teams;
        },
        err => this.ns.showNotification('error', err.message)
      );
  }

  trackByTeamId(index: number, team: Teams) {
    return team._id;
  }

  isTeamLoading(team: Teams): boolean {
    return this.teamDetailsLoading.has(team._id);
  }

  isTeamExpanded(team: Teams): boolean {
    return this.expandedTeamIds.has(team._id);
  }

  toggleTeam(team: Teams): void {
    if (this.expandedTeamIds.has(team._id)) {
      this.expandedTeamIds.delete(team._id);
      return;
    }

    this.expandedTeamIds.add(team._id);
    this.loadTeamDetails(team);
  }

  loadTeamDetails(team: Teams): void {
    if (!team || !team._id || !this.passionProjectId) {
      return;
    }

    if (this.teamDetailsLoading.has(team._id) || this.teamDetailsLoaded.has(team._id)) {
      return;
    }

    this.teamDetailsLoading.add(team._id);
    this._passionProjectService
      .getTeamsById(this.passionProjectId, team._id)
      .pipe(finalize(() => this.teamDetailsLoading.delete(team._id)))
      .subscribe(
        res => {
          const detailedTeam = res.teams && res.teams.length ? res.teams[0] : null;
          if (!detailedTeam) {
            return;
          }

          const hydratedTeam = this.mapTeamAgreements(detailedTeam);
          Object.assign(team, hydratedTeam);
          this.teamDetailsLoaded.add(team._id);
        },
        err => this.ns.showNotification('error', err.message)
      );
  }

  mapTeamAgreements(team: Teams): Teams {
    if (team && Array.isArray(team.members)) {
      team.members = team.members.map((member: any) => {
        const memberInfo = member && member.member_info ? member.member_info : member;
        const agreement = memberInfo && memberInfo.contract ? memberInfo.contract : null;
        const contract = agreement ? agreement : null;
        const pathMatch = contract && contract.resource_path ? contract.resource_path.match(/([^/]+\.pdf)$/i) : null;
        const fileName = pathMatch && pathMatch.length ? pathMatch[0] : '';

        return {
          ...member,
          contractUrl: (contract && contract.resource_url) || member.contractUrl || null,
          contractResourceId: (contract && contract.resource_id) || member.contractResourceId || null,
          contractFileName: fileName
        };
      });
    }

    return team;
  }

  private fetchTeamDetailsInline(teamId: string): void {
    if (!teamId || !this.passionProjectId) {
      return;
    }

    this._passionProjectService.getTeamsById(this.passionProjectId, teamId).subscribe(
      res => {
        const detailedTeam = res && res.teams && res.teams.length ? res.teams[0] : null;
        if (!detailedTeam) {
          return;
        }

        const hydratedTeam = this.mapTeamAgreements(detailedTeam);
        const team = this.projectTeams && this.projectTeams.find(t => t._id === teamId);
        if (team) {
          Object.assign(team, hydratedTeam);
          this.teamDetailsLoaded.add(teamId);
        }
      },
      err => this.ns.showNotification('error', err.message)
    );
  }

  uploadContract(event: Event, member: any, teamId: string, modelName: string) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];
    member.uploadProgress = 0;

    if (file.type !== 'application/pdf') {
      this.ns.showNotification('error', 'Only PDF files are allowed.');
      input.value = '';
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      this.ns.showNotification('error', 'File size should not exceed 5MB.');
      input.value = '';
      return;
    }

    let resource_data = null;

    this.ns.upload_resource(modelName, file).subscribe(
      (res: any) => {
        switch (res.type) {
          case HttpEventType.Sent:
            break;
          case HttpEventType.ResponseHeader:
            break;
          case HttpEventType.UploadProgress:
            member.uploadProgress = Math.round(res.loaded / res.total * 100);
            break;
          case HttpEventType.Response:
            resource_data = res.body.resource_info[0];

            if (res.body && res.body.resource_info && res.body.resource_info.length > 0) {
              resource_data = res.body.resource_info[0];
            }

            if (!resource_data) {
              this.ns.showNotification('error', 'Upload failed. Please try again.');
              return;
            }

            const resourcePath = resource_data.path || resource_data.resource_path || '';
            const studentId = member._id || member.student_id;
            const payload = {
              project_id: this.passionProjectId,
              team_id: teamId,
              student_id: studentId,
              resource_id: resource_data.resource_id,
              resource_path: resourcePath,
              resource_url: resource_data.url
            };

            if (!payload.project_id || !payload.team_id || !payload.student_id || !payload.resource_path) {
              this.ns.showNotification('error', 'Upload succeeded, but required linking details are missing.');
              member.uploadProgress = 0;
              input.value = '';
              return;
            }

            this._passionProjectService.createProjectAgreement(payload).subscribe(
              () => {
                member.contractUrl = resource_data.url;
                member.contractResourceId = resource_data.resource_id;

                this.ns.showNotification('success', 'Contract uploaded successfully.');
                input.value = '';
                this.fetchTeamDetailsInline(teamId);
              },
              (err) => {
                this.ns.showNotification('error', err.message || 'Unable to link contract to the team.');
                input.value = '';
              }
            );

            setTimeout(() => {
              member.uploadProgress = 0;
            }, 1000);
        }
      },
      () => {
        this.ns.showNotification('error', 'Unable to upload file. Please try again.');
        member.uploadProgress = 0;
        input.value = '';
      }
    );
  }

downloadContract(member: any) {
  if (!member || !member.contractUrl) {
    this.ns.showNotification('error', 'Contract not available');
    return;
  }

  const fileName =
    member.contractFileName ||
    this.getFileNameFromUrl(member.contractUrl) ||
    'contract.pdf';

  fetch(member.contractUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Download failed');
      }
      return response.blob();
    })
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = blobUrl;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);

      //IMPORTANT: delay revoke
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 1000);
    })
    .catch(() => {
      this.ns.showNotification(
        'error',
        'Unable to download the file. Please try again.'
      );
    });
}


_downloadContract(member: any) {
  if (!member || !member.contractUrl) {
    this.ns.showNotification('error', 'Contract not available');
    return;
  }

  const fileName =
    member.contractFileName ||
    this.getFileNameFromUrl(member.contractUrl) ||
    'contract.pdf';

  fetch(member.contractUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Download failed');
      }
      return response.blob();
    })
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(() => {
      this.ns.showNotification(
        'error',
        'Unable to download the file. Please try again.'
      );
    });
}

  getFileNameFromUrl(url: string): string {
    try {
      return decodeURIComponent(url.split('/').pop() || 'contract.pdf');
    } catch {
      return 'contract.pdf';
    }
  }

  removeContract(member: any, teamId: string) {
    const studentId = member && (member._id || member.student_id);
    const payload = {
      project_id: this.passionProjectId,
      team_id: teamId,
      student_id: studentId,
      resource_id: '',
      resource_path: '',
      resource_url: ''
    };

    this._passionProjectService.createProjectAgreement(payload).subscribe(
      () => {
        member.contractUrl = null;
        member.contractResourceId = null;
        member.agreement = null;

        this.ns.showNotification('success', 'Contract removed successfully.');
      },
      (err) => {
        this.ns.showNotification('error', err.message || 'Unable to remove the contract.');
      }
    );
  }

  getContractTooltip(): string {
    if (this.role === this.ROLE_STUDENT) {
      return 'Please download this contract, sign it, and upload it here.';
    }

    return 'Upload the contract for the student to review, sign, and return here.';
  }

  submitMemberFeedback(): void {
    if (!this.feedbackContext) {
      return;
    }

    const { team, member, rating, comment } = this.feedbackContext;
    if (!team || !member) {
      return;
    }

    const trimmedComment = comment ? comment.trim() : '';
    if (!rating || !trimmedComment) {
      this.ns.showNotification('info', 'Please add both a rating and feedback before submitting.');
      return;
    }

    const studentId = member._id || member.id || member.student_id || member.user_id;
    if (!studentId) {
      this.ns.showNotification('error', 'Unable to identify the student for feedback.');
      return;
    }

    member.feedbackSubmitting = true;

    const payload = {
      project_id: this.passionProjectId,
      team_id: team._id,
      student_id: studentId,
      rating,
      feedback: trimmedComment
    };

    this._passionProjectService
      .rateTeamMember(payload)
      .pipe(finalize(() => (member.feedbackSubmitting = false)))
    .subscribe({
        next: (res: any) => {
          this.ns.showNotification('success', (res && res.message) || 'Feedback submitted successfully.');
          this.getTeams();
        },
        error: (err: any) => {
          this.ns.showNotification('error', (err && err.message) || 'Unable to submit feedback.');
        }
      });
  }

  private getCurrentUserId(): string {
    return this.userId ? this.userId.toString() : '';
  }

  private isCurrentUserMember(member: any): boolean {
    if (!member || !this.userId) {
      return false;
    }

    const memberIds = [member._id, member.student_id, member.user_id];
    const currentUserId = this.getCurrentUserId();
    return memberIds.some((id) => id && id.toString() === currentUserId);
  }

  private isCurrentUserProjectMentor(): boolean {
    if (!this.userId || !this.passionProject || !this.passionProject.project_mentors) {
      return false;
    }

    const currentUserId = this.getCurrentUserId();
    return this.passionProject.project_mentors.some(
      (mentor) => mentor && mentor.id && mentor.id.toString() === currentUserId
    );
  }

  canShowFeedbackButton(member: any): boolean {
    if (!member) {
      return false;
    }

    if (this.role === this.ROLE_STUDENT) {
      return this.isCurrentUserMember(member);
    }

    return this.role === this.ROLE_ORG_ADMIN || this.isCurrentUserProjectMentor();
  }

  getFeedbackButtonLabel(member: any): string {
    if (this.role === this.ROLE_STUDENT && this.isCurrentUserMember(member)) {
      return 'View Feedback';
    }

    return 'Give feedback';
  }

  canSubmitMemberFeedback(): boolean {
    return this.role === this.ROLE_ORG_ADMIN || this.isCurrentUserProjectMentor();
  }

  private hasAgreementFromApi(member: any): boolean {
    if (!member) {
      return false;
    }
    return Boolean(member.contractUrl || member.contractResourceId || member.contractFileName);
  }

  canUploadContract(member:any): boolean {
    if (this.role === this.ROLE_STUDENT) {
      return this.isCurrentUserMember(member) && this.hasAgreementFromApi(member);
    }

    return this.role === this.ROLE_ORG_ADMIN || this.isCurrentUserProjectMentor() || this.isCurrentUserMember(member);
  }

  openMemberFeedback(team: Teams, member: any): void {
    if (!team || !member) {
      return;
    }

    if (!this.canShowFeedbackButton(member)) {
      return;
    }

    this.feedbackContext = { member, team, rating: 0, comment: '' };

    if (!this.memberFeedbackModal) {
      return;
    }

    this.memberFeedbackModalRef = this.modalService.open(this.memberFeedbackModal, { size: 'lg', backdrop: 'static' });
    this.memberFeedbackModalRef.result
      .then(() => this.clearFeedbackContext())
      .catch(() => this.clearFeedbackContext());
  }

  submitMemberFeedbackFromModal(): void {
    if (!this.feedbackContext) {
      return;
    }

    this.submitMemberFeedback();
    if (this.memberFeedbackModalRef) {
      this.memberFeedbackModalRef.close();
    }
  }

  setFeedbackRating(value: number): void {
    if (!this.feedbackContext) {
      return;
    }

    this.feedbackContext.rating = value;
  }

  private clearFeedbackContext(): void {
    this.feedbackContext = null;
    this.memberFeedbackModalRef = null;
  }

  getMemberFeedbackEntries(): any[] {
    if (!this.feedbackContext || !this.feedbackContext.member) {
      return [];
    }

    const member = this.feedbackContext.member;
    const entries: any[] = [];

    [
      member.feedbackHistory,
      member.feedback_entries,
      member.feedbackEntries,
      member.feedback,
      member.feedback_list,
      member.feedbacks
    ].forEach(raw => this.appendNormalizedFeedbackEntries(entries, raw));

    if (member.member_info) {
      [
        member.member_info.feedbacks,
        member.member_info.feedbackHistory,
        member.member_info.feedback_entries,
        member.member_info.feedbackEntries
      ].forEach(raw => this.appendNormalizedFeedbackEntries(entries, raw));
    }

    return entries;
  }

  hasMemberFeedbackEntries(): boolean {
    return this.getMemberFeedbackEntries().length > 0;
  }

  getRatingArray(value: number): number[] {
    const rating = Math.max(0, Math.min(5, Number(value) || 0));
    return Array.from({ length: rating }, (_, idx) => idx + 1);
  }

  private appendNormalizedFeedbackEntries(target: any[], source: any): void {
    if (!source) {
      return;
    }

    if (Array.isArray(source)) {
      source.forEach(entry => {
        const normalized = this.normalizeFeedbackEntry(entry);
        if (normalized && (normalized.comment || normalized.rating || normalized.created_at)) {
          target.push(normalized);
        }
      });
    } else {
      const normalized = this.normalizeFeedbackEntry(source);
      if (normalized && (normalized.comment || normalized.rating || normalized.created_at)) {
        target.push(normalized);
      }
    }
  }

  private normalizeFeedbackEntry(entry: any): any {
    if (!entry) {
      return null;
    }

    return {
      comment: entry.feedback || entry.comment || entry.text || entry.note || '',
      rating: typeof entry.rating === 'number' ? entry.rating : Number(entry.rating) || 0,
      created_at: entry.created_at || entry.date || entry.uploaded_at,
      givenBy:
        entry.givenBy ||
        entry.giver ||
        entry.mentor ||
        entry.mentor_name ||
        entry.mentor_username ||
        entry.mentor_id ||
        entry.mentor_name ||
        entry.mentor_username ||
        'Mentor'
    };
  }

  openSearchTeamModal(content) {
    this.searchTeamModalRef = this.ngModal.open(content);
  }

  openCreateTeamModal(content) {
    this.createTeamModalRef = this.ngModal.open(content);
  }

  closeModalCreateTeam(val) {
    if (val == 'closeModal') {
      this.createTeamModalRef.close();
      this.searchTeamModalRef.close();
      this.getTeams();
    }
  }

  addTeam() {
    this.searchTeamModalRef.close();
    if (this.searchedTeam) {
      if (typeof this.searchedTeam == 'string') return;


      this.loader = true;

      const projectIds: Array<string> = [this.passionProject._id];
      this.searchedTeam.projects.forEach(val => projectIds.push(val._id));

      // const teamMembers: Array<string> = [this.passionProject._id];
      const teamMembers: Array<string> = [];
      this.searchedTeam.members.forEach(val => teamMembers.push(val._id));

      const formData: EditTeamRequest = {
        team_id: this.searchedTeam._id,
        project_id: projectIds,
        team_name: this.searchedTeam.name,
        team_logo: this.searchedTeam.logo,
        team_members: teamMembers
      };
      this._passionProjectService
        .editTeam(formData)
        .pipe(finalize(() => this.loader = false))
        .subscribe(
          editTeam => {
            this.ns.showNotification('success', editTeam.message);
            this.getPassionProject();
            this.searchedTeam = null;
          },
          err => this.ns.showNotification('error', err.message)
        );
    }

  }

  editTeam(team: Teams) {
    this._sharedPassionProjectTeamService.changeteam(team);
    this.redirect('/passion-projects/teams/edit');
  }

  viewTeam(team: Teams) {
    this._sharedPassionProjectTeamService.changeteam(team);
    this.redirect('/passion-projects/team', team);
  }

  deleteSearchedTeam() {
    this.searchedTeam = null;
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? []
        : this.teamList.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )

  formatter = (x: { name: string }) => x.name;

  redirect(path: string, team: any = '') {
    if (this.searchTeamModalRef) { this.searchTeamModalRef.close(); }
    if(team) {
      this.router.navigate([path], { queryParams: { project_id: this.passionProjectId, team_id: team._id} });
    }
    else {
      this.router.navigate([path], { queryParams: { project_id: this.passionProjectId} });
    }
  }

  redirectToEdit(path: string) {
    if (this.searchTeamModalRef) this.searchTeamModalRef.close();
    this.router.navigate([path], {queryParams: {id: this.passionProjectId}});
  }

  ngOnDestroy() {
     if (this.orgLogoSub) {
      this.orgLogoSub.unsubscribe();
    }

    this.socket_service.leave_room(this.room_id, localStorage.getItem('user_id'));

    if (this.sharedPassionProjectSubscription) this.sharedPassionProjectSubscription.unsubscribe();
    if (this.sharedTeamListSubscription) this.sharedTeamListSubscription.unsubscribe();
  }

  /**
   * Check if the current user has access to view documents
   * - If public: everyone has access
   * - If private: only authorized users have access
   */
  hasDocumentAccess(): boolean {
    if (!this.passionProject || !this.passionProject.project_resources || this.passionProject.project_resources.length === 0 ) {
      return false;
    }

    // If the entire field is public, everyone has access
    if (this.passionProject.resource_accessibility === 'public') {
      return true;
    }

    // If private, check if user is authorized
    const isProjectCreator = this.passionProject.created_by === this.userId;
    const isProjectMentor = this.passionProject.project_mentors &&
                             this.passionProject.project_mentors.some(mentor => mentor.id === this.userId);
    const isAllowedRole = [Roles.TEACHER, Roles.MENTOR, Roles.SUPER_ADMIN, Roles.ORG_ADMIN].includes(this.role as Roles);
    const isTeamMember = this.projectTeams &&
                         this.projectTeams.some(team =>
                           team.members &&
                           team.members.some(member => member._id === this.userId)
                         );

    return isProjectCreator || isProjectMentor || isAllowedRole || isTeamMember;
  }

  /**
   * Get resources directly from API without filtering
   */
  getAccessibleResources() {
    if (!this.passionProject || !this.passionProject.project_resources) {
      return [];
    }

    return this.passionProject.project_resources;
  }

  /**
   * Check if the current user can view the documents section
   * - If public: visible to everyone
   * - If private: visible only to authorized users
   */
  canViewDocumentsSection(): boolean {
    return this.hasDocumentAccess();
  }

  openVideo(videoResources) {
    this.modalService.open(videoResources, { size: 'md' });
  }


  openProjRes(projectResource) {
    this.projectResData = projectResource;
    if (projectResource.url) {
      let urlRegex = /^(https?:\/\/[^/]+)/;
      if (projectResource.url.match(urlRegex)) {
        if (projectResource.url.match(urlRegex)[0] == 'https://www.youtube.com') {
          this.youtubeLinkFlag = true;
          this.showProjres = true;
        } else {
          this.youtubeLinkFlag = false;
          this.showProjres = false;
          window.open(projectResource.url, "blank")

        };
      }
    } else {
      this.showProjres = true;
    }
  }

  closeProjRes() {
    this.showProjres = false;
    this.youtubeLinkFlag = false;
  }

  savePlayer(player) {
    player.target.playVideo();
  }

  created_passion_project(project) {
    return this.UserRole.create_permission(project)
  }

  is_chat_true = false;
  show_group_name
  open_chat(mentor, pc, type) {
    this.is_chat_true = true;
    this.show_group_name = type;
    this.group_details = pc;
    if (type == 'team') {
      this.view_room_group(pc.room_id, pc, type)
    } else {
      this.avatar_url = pc.avatar_url;
      this.chat_user_name = pc.name;
      this.group_details = pc;
      this.view_room(pc.room_id);
    }
  }

  open_chat_mentor(mentor, type) {
    if (!this.is_chat_room()) {
      this.init_mentor_chat();
    } else {
      this.open_chat(mentor, this.passionProject.mentor_chat['chat_room'], type)
    }
  }

  // close chat model
  close_chat(group_details) {
    this.is_chat_true = !this.is_chat_true;
    this.leave_group(group_details)
  }

  room_id = '';
  my_message = [];
  avatar_url = [];
  chat_user_name = '';
  avatar_chat_color = []
  username = '';
  group_details: any[] = [];
  group_lists: any[] = [];
  view_room(room_id) {
    this.my_message = [];
    if (this.room_id != null || this.room_id != '') {
      this.socket_service.leave_room(this.room_id, localStorage.getItem('user_id'));
    }

    this.room_id = room_id;

    this.socket_service.view_room(room_id).subscribe(view_room => {
      this.my_message = view_room.messages;
      this.socket_service.join_room(this.userId, room_id);
      this.group_details['unread_message_count'] = 0;
      let list = document.getElementById('message');
      let length = list.childNodes.length;

      if (list != null && list.hasChildNodes()) {
        for (let i = 0; i <= length; i++) {
          list.removeChild(list.childNodes[0]);
        }
      }
    },
      (err) => {
        this.ns.showNotification('error', err.message)
      })
  }

  all_date = [];
  get_Date() {
    this.all_date = [];
    let last_date = new Date(this.my_message[this.my_message.length - 1].created_at).toDateString();
    for (let i = 0; i < this.my_message.length - 2; i++) {
      if (new Date(this.my_message[i].created_at).toDateString() != last_date) {
        this.all_date[i] = (new Date(this.my_message[i].created_at).toDateString());
        last_date = new Date(this.my_message[i].created_at).toDateString();
      }
    }
  }

  getName(pc) {
    if (pc.last_name) {
      return pc.name[0].toUpperCase() + pc.last_name[0].toUpperCase();
    }
    else {
      if (pc.name) {
        return pc.name[0].toUpperCase();
      }
      return 'U';
    }
  }

  get_time(date) {
    return this.ns.formatAMPM(new Date(date))
  }
  
  message_view = '';
  send_message() {
    if (this.message_view == '') {
      this.ns.showNotification('info', 'Enter Some message for your friend');
      return;
    }

    if (!this.room_id) {
      this.ns.showNotification('info', 'Please join with the person first..');
      return;
    }

    this.socket_service.send_message(this.userId, this.room_id, this.message_view, null);
    this.message_view = '';
  }

  view_room_group(room_id, group_details, type) {
    this.avatar_url = group_details.avatar_url;
    this.chat_user_name = group_details.name;
    this.group_details = group_details;
    this.view_room(room_id)
  }

  is_team_object(team) {
    if (Object.keys(team.group_chat).length > 0) {
      if (team.group_chat.user_status == "deactivate") {
        return false;
      }
      return true;
    }
    return false;
  }

  exit_group(group_team) {
    if (confirm('Are you sure to exit this group ?')) {
      this.socket_service.exit_group(group_team.room_id).subscribe(exit_group => {
        this.ns.showNotification('success', exit_group.message);
        this.is_chat_true = false;
        this.getTeams();
      },
        (err) => {
          this.ns.showNotification('error', err.message);
        })
    }
    return;
  }

  delete_group(group_team) {
    if (confirm('Are you sure to delete this group ?')) {
      this.socket_service.delete_group(group_team.room_id).subscribe(delete_group => {
        this.ns.showNotification('success', 'Successfully deleted the group');
        this.is_chat_true = false;
        this.getTeams();
      },
        (err) => {
          this.ns.showNotification('error', err.message);
        })
    }
    return;
  }

  leave_group(group_team) {
    this.socket_service.leave_room(group_team.room_id, localStorage.getItem('user_id'));
  }


  weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];


  is_day(date) {
    let day = new Date(date);
    return this.weekday[day.getUTCDay()];
  }

  is_mentor_present() {
    let mentor_list = this.passionProject.project_mentors.find(list => list['id'] == this.userId);
    return mentor_list;
  }

  scrollTop_height = 200
  get_height(height) {
    if (height) {

      let messgae_height = this.my_message.length;
      // let unread_mesage = this.get_count(this.group_details);
      // if (unread_mesage > 0) {
      //   this.scrollTop_height = height - messgae_height;
      // } else {
      this.scrollTop_height = height;
      // }

      return this.scrollTop_height;
    }
    return this.scrollTop_height
  }

  init_mentor_chat() {
    let project_name = this.passionProject.project_title;
    let project_Des = this.passionProject.project_overview.description;
    let project_id = this.passionProject._id;
    let admin_list = [];
    for (let i = 0; i < this.passionProject.project_mentors.length; i++) {
      admin_list.push(this.passionProject.project_mentors[i]['id']);
    }
    this.socket_service.initialize_chat(project_name, admin_list, project_Des, project_id).subscribe(init_chat => {
      this.open_chat('', init_chat.chat_room, 'single')
      this.passionProject.mentor_chat['room_status'] = true;
    }, (err) => {
      console.log(err);
    })
  }

  chat_with(mentor_info) {
    if (this.is_chat_room()) {
      return 'chat with mentor';
    }
    return 'Initialze Chat';
  }

  get_passion_project_proposal() {
    this.socket_service.get_passion_project_proposal(this.passionProject._id).subscribe(proposal_list => {
      if (proposal_list && proposal_list.rooms_data) {
        this.passion_project_mentor_list = proposal_list.rooms_data;
      }
    },
      (err) => {
        console.log(err);
      })
  }

  get_user_chat(user_chat) {
    this.open_chat('', user_chat, 'single');
  }

  get_username(username) {
    let split_value = username.split('-');
    if (split_value.length > 1 && (this.UserRole.matchRole('student') && !this.is_mentor_present())) {
      return split_value[1]
    }
    return username;
  }

  get_length_message() {
    let list = document.getElementById('message');
    let length = list.childNodes.length;
    return length
  }

  get_message() {
    if (this.socket_service.receive_message_view.length > 0) {
      this.my_message.push(this.socket_service.receive_message_view[0]);
      this.socket_service.receive_message_view = [];
    }
    return this.my_message;
  }

  image_url;
  openImgModal(content, img_info) {
    this.image_url = img_info;
    this.modalReview.open(content, { windowClass: 'prevImgModal', centered: true });
  }

  openInNewWindow(viewSubmissions) {
    window.open(viewSubmissions.url);
  }

  download_file() {
    //
  }

  //FOR NEW DESIGN 
  onGoBack() {
    if(this.isMentorProfile){
      let mentorId = localStorage.getItem('mentorId');
      this.router.navigate(['/mentorship/mentor-profile'], { queryParams: { id: mentorId } });
    } else{
      this.router.navigate(['/passion-projects']);
    }
  }

  onGetTeamStatus() {
    this.getTeams();
  }

  /**
   * For student show new mentor profile page
   */
  gotoUserProfilePage(value: string, userdata: any) {
    if (this.perm.hasRole(this.ROLE_STUDENT) && userdata.role && this.perm.userHasAnyRole(this.allowedRoles, userdata.role)) {
      this.router.navigate(['/mentorship/mentor-profile'], { queryParams: { id: value } });
    }
    else {
      this.router.navigate(['public-profile'], { queryParams: { instructor_id: value } });
    }
  }


    /**
   * To open session details page
   * @param {string} sessionId - To get session id
   */
  onViewSessionDetails(sessionId: string, sessionType: string) {
    if(this.isTeacherOrMentor && !this.isEditRights){
      this.ns.showNotification('error', "You don't have permission to view this page.");
      return false;
    }
    this.router.navigate(['/mentorship/mentorship-details'], { queryParams: { id: sessionId, type: sessionType,passionProjectID: this.passionProjectId, ref:'mosic' } });
  }

  /**
   * To upload webinar recording
   * @param event
   */
  uploadWebinarRecording(event:any) {
    if(event.status == false) {
      return false;
    }
    const postData = {
      'event_id': event.postData.event_id,
      'event_type': event.postData.event_type,
      'video_url': event.postData.event_file_path
    }
    this.processingStatus = true;
    this.processingCompleted = false;
    this._passionProjectService.addWebinarRecording(postData).subscribe((res: any)=> {
      this.processingStatus = false;
      this.processingCompleted = true;
      this.getPassionProject();
      this.ns.showNotification('success', res.message);
    }, (error: any)=> {
      this.processingStatus = false;
      this.ns.showNotification('error', error.message);
    });
  }
}
